<header class="h-16 bg-white">
  <div class="flex items-center justify-between h-full px-6">
    <app-breadcrumb></app-breadcrumb>
    <app-user-menu></app-user-menu>
  </div>
</header>
